// ** React Imports
import { useHistory, useLocation } from "react-router-dom";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";

// ** Custom Hooks
import useFilterActivityDate from "hooks/filters/useFilterActivityDate";

// ** Utils & Helpers
import generatePath from "utils/generatePath";
import { useEffect } from "react";

// #####################################################

const useActivityDateSelector = ({ date, path }) => {
	const { t } = useTranslation("common");
	const history = useHistory();
	const filterActiveDate = useFilterActivityDate({
		initial: date,
	});

	const { items, selected, setSelected } = filterActiveDate;

	const location = useLocation();

	useEffect(() => {
		if (location.pathname === "/activity") setSelected("any");
	}, [location.key]);

	const renderActivityDateSelector = () => (
		<SelectorSelectSingle
			label={t("filtersAndSelectors:periodLabel")}
			items={items}
			selected={selected}
			onAccept={(value) => {
				setSelected(value);
				const generatedPath = generatePath(path, {
					date: value,
					page: 1,
				});
				history.push(generatedPath);
			}}
			withMobileVersion
		/>
	);

	// #####################################################

	return {
		filterActiveDate,
		renderActivityDateSelector,
	};
};

export default useActivityDateSelector;

// #####################################################
